import Vue from 'vue';
import VueMaterial from 'vue-material';
import 'sone-vue-material/src/style/index.scss';

Vue.component('router-link', Vue.options.components.RouterLink);
Vue.component('router-view', Vue.options.components.RouterView);
Vue.use(VueMaterial);
